import React from 'react';

// general toggle component, that can be used to manage basic on/off logic
export const useToggle = () => {
  const [value, setValue] = React.useState<boolean>(false);

  const toggle = React.useCallback(() => {
    setValue((v) => !v);
  }, [value]);
  return [value, toggle] as const;
};
